import SettingsIcon from '@mui/icons-material/Settings';
import Box from '@mui/material/Box';
import { keyframes } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { ChatBubbleIcon } from '../../FloatingWidget/ChatBubbleIcon.tsx';

export type ChatAiBubbleVariant = 'default' | 'error';

export type ChatAiBubbleProps = {
  variant?: ChatAiBubbleVariant;
  animate?: boolean;
};

const rotate = keyframes({
  from: {
    transform: 'rotate(0deg)',
  },
  to: {
    transform: 'rotate(360deg)',
  },
});

export function ChatAiBubble({ variant = 'default', animate = false }: ChatAiBubbleProps) {
  const isError = variant === 'error';

  return (
    <Box
      sx={theme => ({
        position: 'relative',
        marginTop: 0.5,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: isError ? theme.palette.error.light : theme.palette.charts.lavender,
      })}
    >
      <ChatBubbleIcon width={27} height={27} />
      <Typography
        sx={[
          {
            fontSize: 11,
            fontWeight: 'fontWeightBold',
          },
          theme => ({
            position: 'absolute',
            color: isError ? theme.palette.error.main : theme.palette.charts.plum,
            top: '40%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }),
        ]}
      >
        AI
      </Typography>
      {animate && (
        <SettingsIcon
          sx={{
            color: 'primary.dark',
            position: 'absolute',
            right: -4,
            top: -4,
            width: '12px',
            height: '12px',
            animation: `${rotate} 2s linear infinite`,
          }}
        />
      )}
    </Box>
  );
}
